import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import { withRouter } from 'react-router-dom';
import BorrowerMailboxContentSC, {
  TopContentWrapSC,
  BottomContentWrapSC,
  /*   EmptySC, */
} from './borrower-mailbox-content.styled';
import SectionSwitch from './section-switch';
import MailboxTable from './mailbox-table';
import DocumentsTable from './documents-table';
/* import { SmallText } from '../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang'; */
import SmsTable from './sms-table';
import RequestsTable from './requests-table';
import LetterTable from './letter-table';

const categories = [
  {
    label: 'borrower_mailbox_section_documents',
    name: 'documents',
  },
  {
    label: 'borrower_mailbox_section_sms',
    name: 'sms',
  },
  {
    label: 'borrower_mailbox_section_email',
    name: 'emails',
  },
  {
    label: 'borrower_mailbox_section_letters',
    name: 'letters',
  },
  {
    label: 'borrower_mailbox_section_requests',
    name: 'requests',
  },
];

const _BorrowerMailboxContent = ({
  getMailboxEmails,
  emails,
  getMailboxDocuments,
  documents,
  getMailboxSms,
  sms,
  getMailboxRequests,
  requests,
  getMailboxLetters,
  letters,
}) => {
  const [isActive, setIsActive] = useState('documents');

  const setActiveCategory = (category) => {
    setIsActive(category);
  };

  useEffect(() => {
    getMailboxEmails();
  }, [getMailboxEmails]);

  useEffect(() => {
    getMailboxDocuments();
  }, [getMailboxDocuments]);

  useEffect(() => {
    getMailboxSms();
  }, [getMailboxSms]);

  useEffect(() => {
    getMailboxRequests();
  }, [getMailboxRequests]);

  useEffect(() => {
    getMailboxLetters();
  }, [getMailboxLetters]);

  return (
    <BorrowerMailboxContentSC>
      <TopContentWrapSC>
        <SectionSwitch
          categories={categories}
          isActive={isActive}
          setActiveCategory={(category) => setActiveCategory(category)}
        />
      </TopContentWrapSC>
      <BottomContentWrapSC>
        {isActive === 'documents' ? (
          <DocumentsTable documents={documents} />
        ) : isActive === 'sms' ? (
          <SmsTable
            messages={sms}
            type="sms"
          /> /* (
          <EmptySC>
            <div className="empty-table">
              <SmallText className="black-transparent bold">
                <FormattedMessage
                  id="mailbox_sms_empty"
                  defaultMessage={dlt['mailbox_sms_empty']}
                />
              </SmallText>
            </div>
          </EmptySC>
        )  */
        ) : isActive === 'requests' ? (
          <RequestsTable
            requests={requests}
          /> /* <EmptySC>
            <div className="empty-table">
              <SmallText className="black-transparent bold">
                <FormattedMessage
                  id="mailbox_requests_empty"
                  defaultMessage={dlt['mailbox_requests_empty']}
                />
              </SmallText>
            </div>
          </EmptySC> */
        ) : isActive === 'emails' ? (
          <MailboxTable messages={emails} type="emails" />
        ) : isActive === 'letters' ? (
          <LetterTable messages={letters} type="letters" />
        ) : null}
      </BottomContentWrapSC>
    </BorrowerMailboxContentSC>
  );
};

const mapStateToProps = (state) => {
  return {
    emails: state.mailbox.emails,
    documents: state.mailbox.documents,
    sms: state.mailbox.sms,
    requests: state.mailbox.personal_requests,
    letters: state.mailbox.letters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getMailboxEmails: ActionCreators.getMailboxEmails,
      getMailboxDocuments: ActionCreators.getMailboxDocuments,
      getMailboxSms: ActionCreators.getMailboxSms,
      getMailboxRequests: ActionCreators.getMailboxRequests,
      getMailboxLetters: ActionCreators.getMailboxLetters,
    },
    dispatch
  );
};

const BorrowerMailboxContent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_BorrowerMailboxContent)
);

export default BorrowerMailboxContent;
